/**
 * Channels – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

export default function ChannelsLineupIcon({
  focused,
  width,
  height,
  margin,
  fromMenu = false,
  fromFloatingMenu = false,
}: Props & { fromMenu?: boolean; fromFloatingMenu?: boolean }) {
  const color = fromMenu
    ? Colors['menu']['icon'][focused ? 'focused' : 'unfocused']
    : Colors[focused ? 'dark' : 'light'];
  const defaultWidth = fromFloatingMenu
    ? 32 * Screen.widthRatio
    : 22 * Screen.widthRatio;
  const defaultHeight = fromFloatingMenu
    ? 30 * Screen.widthRatio
    : 20 * Screen.widthRatio;
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={(width ? width : defaultWidth) * Screen.widthRatio}
      height={(height ? height : defaultHeight) * Screen.widthRatio}
      viewBox='0 0 44 47'
      fill='none'
      style={{ margin: margin ?? 0 }}
    >
      <path
        d='M13.8335 41.1036C13.8335 39.5902 14.8928 38.3634 16.1995 38.3634H41.4371C42.7438 38.3634 43.8031 39.5902 43.8031 41.1036V43.8439C43.8031 45.3572 42.7438 46.5841 41.4371 46.5841H16.1995C14.8928 46.5841 13.8335 45.3572 13.8335 43.8439V41.1036Z'
        fill={color}
      />
      <path
        d='M13.8335 21.9219C13.8335 20.4085 14.8928 19.1817 16.1995 19.1817H41.4371C42.7438 19.1817 43.8031 20.4085 43.8031 21.9219V24.6622C43.8031 26.1756 42.7438 27.4024 41.4371 27.4024H16.1995C14.8928 27.4024 13.8335 26.1756 13.8335 24.6622V21.9219Z'
        fill={color}
      />
      <path
        d='M13.8335 2.74024C13.8335 1.22685 14.8928 0 16.1995 0H41.4371C42.7438 0 43.8031 1.22685 43.8031 2.74024V5.48048C43.8031 6.99388 42.7438 8.22072 41.4371 8.22072H16.1995C14.8928 8.22072 13.8335 6.99388 13.8335 5.48048V2.74024Z'
        fill={color}
      />
      <path
        d='M0 3.20608C0 1.69268 1.0593 0.465836 2.36602 0.465836H7.28735C8.59407 0.465836 9.65337 1.69268 9.65337 3.20608V5.17905C9.65337 6.69244 8.59407 7.91929 7.28735 7.91929H2.36602C1.0593 7.91929 0 6.69244 0 5.17905V3.20608Z'
        fill={color}
      />
      <path
        d='M0 21.8397C0 20.3263 1.0593 19.0995 2.36602 19.0995H7.28735C8.59407 19.0995 9.65337 20.3263 9.65337 21.8397V24.7444C9.65337 26.2578 8.59407 27.4846 7.28735 27.4846H2.36602C1.0593 27.4846 0 26.2578 0 24.7444V21.8397Z'
        fill={color}
      />
      <path
        d='M0 41.405C0 39.8916 1.0593 38.6648 2.36602 38.6648H7.28735C8.59407 38.6648 9.65337 39.8916 9.65337 41.405V43.378C9.65337 44.8914 8.59407 46.1183 7.28735 46.1183H2.36602C1.0593 46.1183 0 44.8914 0 43.378V41.405Z'
        fill={color}
      />
    </svg>
  );
}
